// Any time you have to use some sort of data that would have to affect many separate pages, instead of changing it that many times, change it once here.

export const paths = [
  { name: "Home", path: "/#home" },
  { name: "Events", path: "/articles" },
  { name: "Resources", path: "/resources" },
  { name: "Contact Us", path: "/contact" },
  { name: "About", path: "/about" },
];

export const Location = {
  NORTH: "STEMENJ North",
  SOUTH: "STEMENJ South",
  GENERAL: "STEMENJ"
};

export const PostType = {
  EVENT: "Event",
  RESOURCE: "Resource",
  NEWS: "News",
};

const POST_PAGE_SIZE = 9; // Number of posts per page

// you must declare the accompanying post in articles.js, and the key value in the articles object must be the same as the date in globals.js
const posts = [
  // it is EXTREMELY VITAL that the date is in the format YYYY-MM-DD, specifically the month and day must be 2 digits, so 2025-01-01 is correct, but 2025-1-1 is not
  // accompanying jsx files must have the same name as the date, or it will not work.
  {
    title: "Family Success Center Fair",
    imagePath: "/assets/articles/2025-04-12/thumb.png",
    bannerPath: "/assets/articles/2025-04-12/banner.png",
    postType: PostType.NEWS,
    location: Location.SOUTH,
    date: "2025-04-12",
  },
  {
    title: "Scratch Hackathon 2025 Results",
    imagePath: "/assets/articles/2025-03-18/IMG_6176.jpg",
    bannerPath: "/assets/articles/2025-03-18/code.jpg",
    postType: PostType.EVENT,
    location: Location.NORTH,
    date: "2025-03-18",
  },
  {
    title: "Scratch Hackathon 2025",
    imagePath: "/assets/articles/2025-03-18/code.jpg",
    bannerPath: "/assets/articles/2025-03-18/code.jpg",
    postType: PostType.EVENT,
    location: Location.NORTH,
    date: "2025-02-27",
  },
  {
    title: "STEMENJ South Fundraising Updates",
    imagePath: "/assets/articles/Breadboard.jpg",
    bannerPath: "/assets/articles/Breadboard.jpg",
    postType: PostType.NEWS,
    location: Location.SOUTH,
    date: "2025-04-21",
  },
  {
    title: "Build Balance Brainstorm",
    imagePath: "/assets/articles/2025-04-07/IMG_6880.jpg",
    bannerPath: "/assets/articles/2025-04-07/IMG_6870.mp4",
    postType: PostType.EVENT,
    location: Location.SOUTH,
    date: "2025-04-07",
  },
  {
    title: "STEM Labs",
    imagePath: "/assets/articles/2025-05-02/thumb.png",
    bannerPath: "/assets/articles/2025-05-02/banner.jpg",
    postType: PostType.EVENT,
    location: Location.NORTH,
    date: "2025-05-02",
  },
  {
    title: "Enginnering Day",
    imagePath: "/assets/articles/2025-06-02/thumb.jpg",
    bannerPath: "/assets/articles/2025-06-02/banner.png",
    postType: PostType.EVENT,
    location: Location.NORTH,
    date: "2025-06-02",
  },
  {
    title: "STEM Labs Results",
    imagePath: "/assets/articles/2025-06-15/thumb.jpeg",
    bannerPath: "/assets/articles/2025-06-15/banner.mp4",
    postType: PostType.EVENT,
    location: Location.NORTH,
    date: "2025-06-15",
  },
];

export function getLatestPosts() {
  return posts.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 3);
}

export function getPosts() {
  return posts.sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getPostsByType(type) {
  return posts
    .filter((post) => post.postType === type)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getPostsByLocation(location) {
  return posts
    .filter((post) => post.location === location)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getPostsByPage(page) {
  return posts
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(page * POST_PAGE_SIZE, (page + 1) * POST_PAGE_SIZE);
}

export function getPageCount() {
  return Math.ceil(posts.length / POST_PAGE_SIZE);
}

export function getPostByDate(date) {
  return posts.find((post) => post.date === date);
}
